import { render, staticRenderFns } from "./Clover.vue?vue&type=template&id=055391aa&scoped=true"
import script from "./Clover.vue?vue&type=script&lang=js"
export * from "./Clover.vue?vue&type=script&lang=js"
import style0 from "./Clover.vue?vue&type=style&index=0&id=055391aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055391aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055391aa')) {
      api.createRecord('055391aa', component.options)
    } else {
      api.reload('055391aa', component.options)
    }
    module.hot.accept("./Clover.vue?vue&type=template&id=055391aa&scoped=true", function () {
      api.rerender('055391aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Clover.vue"
export default component.exports